export default {
    view: {
        success: {
            header: "Pesquisa enviada",
            message: "Obrigado pelo seu feedback."
        },
        productChoice: {
            cta: "Salvar",
            processing: "salvando"
        },
        addressForm: {
            cta: "Salvar",
            processing: "salvando"
        }
    },
    delivery: {
        title: "pesquisa de entrega",
        message: "Você recebeu todos os itens listados abaixo?",
        cta: {
            yes: "Sim",
            no: "Não",
            processing: "salvando"
        }
    }
}